import React,{useState, useEffect} from 'react';
import "./css/TopCornerUserPopup.css"
import {getAuth, signOut} from 'firebase/auth';
import {Link, useNavigate} from "react-router-dom" ;
//redux
import { useSelector, useDispatch} from 'react-redux';
import {setLoginStatus, setPhoto, setUserName,setReduxUserID } from "./redux/isLoggedIn"
import {setFirstAppLoad } from "./redux/firstAppLoad"

const TopCornerUserPopup = React.memo(props => {

     //redux stuff
     const reduxIsLoggedIn = useSelector((state) => state.isLoggedIn.reduxIsLoggedIn);
     const reduxFirstAppLoad = useSelector((state) => state.firstAppLoad.reduxFirstAppLoad);
     const reduxUserPhoto = useSelector((state) => state.isLoggedIn.reduxUserPhoto);
     const dispatch = useDispatch();


     //grrr this is for a bug when the app first loads, the userpopup's closing animation fires. 
     //here we have a redux value tracking if its the apps first load. If it is, assign a css class that will hide it with display none
     //until the popup is triggered, setting the redux value to 'false' and thus, the css class to empty
     var hideOnFirstLoad = '';
     if(reduxFirstAppLoad == 'true'){
          hideOnFirstLoad = "TopCornerUserPopup hideOnFirstLoad";
     }
     else{
          hideOnFirstLoad = "TopCornerUserPopup";
     }

     useEffect(() => {

          if(reduxUserPhoto == ''){
               dispatch(setPhoto("http://nick-georgiou.com/languageAppIcons/genericHeadShot.jpg"));
          }else{
               window.localStorage.setItem('userPhoto', reduxUserPhoto);
          }
    
    
     }, [reduxUserPhoto])


     const auth = getAuth();
     const user = auth.currentUser;
     const [loggedInCookie, setLoginCookieStatus] = useState(window.localStorage.getItem('loggedIn')); 
     const navigate = useNavigate();


     var userName;
     var userImage;
     
     if(auth.currentUser){
       userName = user.displayName;
       userImage = reduxUserPhoto;
     }
     else{
       userImage = "blah";
     }
 
     auth.onAuthStateChanged( (user) => {
       if(user){
          setLoginCookieStatus(true);
       }
       else{
          props.setPopupIsOpen(false);
       } 
     })

     const edit = () => {
          navigate('/app/editAccount');
          props.setPopupIsOpen(false);
          props.setClosePopupHack(true);
          setTimeout(function(){
               props.setClosePopupHack(false);
          },300);
     }

     const overlayClickedClose = (event) => {  
          event.preventDefault();
          if(event.target === event.currentTarget) {
               props.setPopupIsOpen(false);
               props.setClosePopupHack(true);
               setTimeout(function(){
                    props.setClosePopupHack(false);
               },300);
          }        
     }

     const logOut = () => {
          //from firebase
          signOut(auth)        
          .then( ()=> {
            //console.log("the user has been logged out");
            setLoginCookieStatus(false);
            window.localStorage.setItem('loggedIn', false);
            dispatch(setLoginStatus(false));  //redux
           // console.log('reduxIsLoggedIn: ' + reduxIsLoggedIn );
            navigate('/app/');

               //localStorage
               window.localStorage.setItem('loggedIn', '');
               window.localStorage.setItem('username', '');
               window.localStorage.setItem('userPhoto', '');
               window.localStorage.setItem('userID', '');
               setLoginStatus(true);
          
          })
          .catch( (err) =>{
              console.log(err.message);
          })
      }


     return (
          // use the ternary in the style here just to force a rerender. Sometimes the component renders faster than the DB info comes in
          // <div className='TopCornerUserPopup userPopupOpen' style = {{display: loggedInCookie ? 'block': 'block' } }>
          <div className={props.popupIsOpen == true  ? 'userPopupOverlay' : hideOnFirstLoad } onClick={overlayClickedClose}>
               <div className={props.popupIsOpen == true  ? 'TopCornerUserPopup userPopupOpen' : hideOnFirstLoad }>
                    <div className='left'>
                         <img src={userImage} className="headshot" />
                    </div>

                    <div className='right'>
                         <p>You are logged in as: <span>{userName}</span></p>
                         <p className='name'> </p>
                         
                         <button className='editButton' onClick = {edit} >Edit</button>
                         <button className='logoutButton' onClick = {logOut} >Log Out</button>
                    </div>

                    {/* //end TopCornerUserPopup */}
               </div>
          </div>//end overlay
     )
})

export default TopCornerUserPopup
